const isBrowser = typeof window === 'object' && typeof document === 'object' && typeof navigator === 'object'
const Swiper = (() => (isBrowser ? require('swiper') : function S() {
}))()

export default Swiper
